<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="epigraph">
<p class="ct"><a class="xref" href="#/pppbookdeal0005#toc">Epigraph</a></p>
<p class="ep">For books are not absolutely dead things…they are as lively, and as vigorously productive as those fabulous dragon’s teeth; and being sown up and down, may chance to spring up armed men.</p>
<p class="ept">—John Milton, <em>Areopagitica</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-bookdeal0006.vue?7f852aa6